export default Object.freeze({
  avatar404: require('@/assets/404_images/404_avatar.png'),
})
